import { MoreVert } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import Box from "@mui/material/Box";
import Chip from '@mui/material/Chip';
import * as React from 'react';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import ToolButton from '../../../components/ToolButton';

export interface TroncTableChip {
    label: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    onDelete?: () => void;
    adminView?: boolean;
    labelType: string;
}

interface TroncMobileToolbarProps {
    onFilterClick: (event: React.MouseEvent<HTMLElement>) => void;
    isFilterOpen: boolean;
    chips?: TroncTableChip[];
    filtersButtonRef?: RefObject<HTMLButtonElement>;
}

export const TroncMobileToolbar = (props: TroncMobileToolbarProps) => {
    const { onFilterClick, isFilterOpen, chips, filtersButtonRef } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (

        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginTop: '16px',
                marginX: '16px'
            }}
        >
            {chips && <Box sx={{ flex: 1, display: 'flex', flexWrap: 'wrap' }}>
                {chips.map((chip) => (
                    <Chip
                        key={`chip-${chip.label}`}
                        variant="filled"
                        label={chip.label}
                        onClick={chip.onClick}
                        onDelete={chip.onDelete}
                        sx={{
                            marginRight: '8px',
                            marginY: '4px',
                            backgroundColor: 'secondary.main',
                            color: theme.palette.info['160p'],
                            '& .MuiChip-deleteIcon': {
                                color: theme.palette.info['160p'],
                            },
                        }}
                        data-qa-id={`chip-${chip.labelType}`}
                    />
                ))}
            </Box>

            }

            <Box sx={{ paddingLeft: '0.5rem' }}>
                <ToolButton
                    iconElement={<MoreVert />}
                    onClick={onFilterClick}
                    tooltip={t('components.filters.filterList')}
                    active={isFilterOpen}
                    buttonRef={filtersButtonRef}
                    dataQaId="tableFiltersButtonMobile"
                />
            </Box>
        </Box>
    )
};
